import React, { forwardRef, useRef, useEffect } from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import { TruncateText } from '../TruncateText/TruncateText.esm.js';

function SubTab({ size = "md", ...props }) {
    const buttonRef = useRef(null);
    useEffect(() => {
        var _a;
        if (props.hasFocus)
            (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [props.hasFocus, buttonRef]);
    const buttonProps = {
        size,
        ...props,
        tabIndex: props.hasFocus ? 0 : -1,
    };
    return React.createElement(Button, { ...buttonProps, ref: buttonRef });
}
const Button = forwardRef(({ id, active = false, size = "md", children, dataMetrics, dataTestId, disabled = false, onClick, onKeyDown, tabIndex, isFirst, isLast, }, ref) => {
    const classes = classNames("tw-flex tw-items-center tw-px-4 tw-box-border tw-font-semibold", "tw-border-r tw-border-l-0 first:tw-border-l tw-border-t-0 tw-border-b-0 tw-border-gray-300 dark:tw-border-gray-950", size === "sm" && "tw-text-[0.688rem] tw-px-5 tw-h-[1.125rem]", size === "md" && "tw-text-xs tw-h-[1.375rem]", size === "lg" && "tw-text-[0.875rem] tw-px-6 tw-h-7", "tw-border-solid", "focus:tw-outline-none focus-visible:tw-ring focus-visible:tw-ring-inset", disabled
        ? "tw-text-disabled dark:tw-text-gray-600"
        : "dark:tw-text-gray-300 tw-cursor-pointer hover:tw-bg-blue-100 dark:hover:tw-bg-gray-800", active
        ? !disabled &&
            "tw-text-blue-700 dark:tw-text-[#38A5FF] tw-bg-white dark:tw-bg-gray-1050 tw-border-t tw-pt-0"
        : "tw-bg-gray-100 dark:tw-bg-gray-1000 tw-text-secondary", active && isFirst
        ? "first:tw-border-gray-300"
        : "first:tw-border-l-transparent", isLast
        ? active
            ? "last:tw-border-r"
            : "last:tw-border-r-0"
        : "tw-border-r");
    const labelText = React.createElement(TruncateText, null, children);
    return (React.createElement("button", { "data-metrics": dataMetrics, "data-testid": dataTestId || id, id: id, className: classes, role: "tab", "aria-selected": active, disabled: disabled, onClick: onClick, onKeyDown: onKeyDown, ref: ref, tabIndex: tabIndex, type: "button", style: { maxWidth: "16rem" } }, labelText));
});
Button.displayName = "Button";

export { SubTab };
//# sourceMappingURL=SubTab.esm.js.map
